import { ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { MsalService } from './msal.service';
import { Injectable, Inject } from '@angular/core';
import { Location } from "@angular/common";
import { InteractionType, AuthenticationResult } from "@azure/msal-browser";
import { MsalGuardConfiguration } from './msal.guard.config';
import { MSAL_GUARD_CONFIG } from './constants';
import { concatMap, catchError, map, switchMap } from 'rxjs/operators';
import { Observable, of, from, EMPTY } from 'rxjs';
// import { Minimatch } from "minimatch";
import { MSAL_INTERCEPTOR_CONFIG } from './constants';
import { MsalInterceptorConfig } from './msal.interceptor.config';
import { Router } from '@angular/router';
import { ExportStateService } from '../service/export-state.service';
import { HomeService } from 'src/app/service/home.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from '../service/common/common.service';

@Injectable()
export class MsalGuard  {
	constructor(
		@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
		@Inject(MSAL_INTERCEPTOR_CONFIG) private msalInterceptorConfig: MsalInterceptorConfig,
		private authService: MsalService, private state: ExportStateService,
		private location: Location, private router: Router,
		private homeService: HomeService,
		private commonService: CommonService,
		private ngxUiLoaderService: NgxUiLoaderService,
		private route: ActivatedRoute
	) { }

	/**
	 * Builds the absolute url for the destination page
	 * @param path Relative path of requested page
	 * @returns Full destination url
	 */
	getDestinationUrl(path: string): string {
		//debugger;
		// Absolute base url for the application (default to origin if base element not present)
		const baseElements = document.getElementsByTagName("base");
		const baseUrl = this.location.normalize(baseElements.length ? baseElements[0].href : window.location.origin);

		// Path of page (including hash, if using hash routing)
		const pathUrl = this.location.prepareExternalUrl(path);

		if (sessionStorage.getItem('userDetails') == undefined) {
			return `${baseUrl}/home`;
		}

		// Hash location strategy
		if (pathUrl.startsWith("#")) {
			return `${baseUrl}/${pathUrl}`;
		}

		// If using path location strategy, pathUrl will include the relative portion of the base path (e.g. /base/page).
		// Since baseUrl also includes /base, can just concatentate baseUrl + path
		return `${baseUrl}${path}`;
	}

	private loginInteractively(url: string): Observable<boolean> {
		if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
			return this.authService.loginPopup({ ...this.msalGuardConfig.authRequest })
				.pipe(
					map(() => true),

					catchError(() => of(false))
				);
		}
		//debugger;
		const redirectStartPage = this.getDestinationUrl(url);
		this.authService.loginRedirect({
			redirectStartPage,
			scopes: [],
			...this.msalGuardConfig.authRequest,
		});
		return of(false);
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
		return this.authService.handleRedirectObservable()
			.pipe(
				concatMap(() => {
					// this.ngxUiLoaderService.start('loader-component');
					if (!this.authService.getAllAccounts().length) {

						return this.loginInteractively(state.url);
					}
					return this.setUserInfo(state.url);
					// return of(true);
				}),
				catchError(() => {
					// this.router.navigate(['./unauthorized']);
					this.router.navigate(['/'])
					localStorage.clear();
					sessionStorage.clear();
					setTimeout(() => {
						this.authService.logout();
					}, 1000);
					return of(false)
				})
			);
	}

	setUserInfo(URL: any) {
		console.log('msal')
		const graphurl = 'https://graph.microsoft.com/v1.0/me'
		const scopes = this.getScopesForEndpoint(graphurl);
		const account = this.authService.getAllAccounts()[0];
		let currentURL = this.route.snapshot
		console.log(URL)
		let chnagedRole: any = sessionStorage.getItem("ChangedRole");

		return this.authService.acquireTokenSilent({ scopes, account })
			.pipe(
				catchError(() => {
					// debugger;
					console.log('error in acquireTokenSilent');
					if (this.msalInterceptorConfig.interactionType === InteractionType.Popup) {
						return this.authService.acquireTokenPopup({ ...this.msalInterceptorConfig.authRequest, scopes });
					}
					const redirectStartPage = window.location.href;
					this.authService.acquireTokenRedirect({ ...this.msalInterceptorConfig.authRequest, scopes, redirectStartPage });
					return EMPTY;
				}),

				// switchMap((result: AuthenticationResult) => {
				switchMap((result: any) => {
					// debugger;
					console.log(result.idToken);
					console.log("result===", result);
					console.log("Token===", result.idTokenClaims['ToyotaGUID']);
					if (('ToyotaGUID' in result.idTokenClaims) && result.idTokenClaims['ToyotaGUID'].length) {
						this.state.setGUIDState(result.idTokenClaims['ToyotaGUID']);

						localStorage.setItem('toyotaGUID', result.idTokenClaims['ToyotaGUID']);
						if (sessionStorage.getItem("expiresOn") === null || sessionStorage.getItem("expiresOn") === undefined || sessionStorage.getItem("expiresOn") === '') {
							localStorage.setItem('token', result.idToken);
							sessionStorage.setItem('expiresOn', (result?.idTokenClaims?.exp));
						}
						let userId = localStorage.getItem("toyotaGUID");
						// this.ngxUiLoaderService.stop('loader-component');
						if (userId != null && ((URL == '/home') || URL.includes('#code') || (URL == '/') || (chnagedRole == 'true'))) {
							// debugger
							this.ngxUiLoaderService.start('loader-component');
							sessionStorage.setItem('ChangedRole', 'false')
							this.homeService.getUserDetails(userId).pipe(
								catchError((error: any) => {
									setTimeout(() => {
										this.ngxUiLoaderService.stop('loader-component');
									}, 500);
									this.router.navigate(['/unauthorized', 'common','true']);
									localStorage.clear();
									sessionStorage.clear();
									setTimeout(() => {
										this.authService.logout();
									}, 3000);
									return of(false);
								})).subscribe((response: any) => {
									if (response?.status == true) {
										sessionStorage.setItem("LoggedIn", 'true');
										this.commonService.setUserLoggedIn(true);
										response.siteList = response.siteList.filter((item: any) => item.name != 'QQQ')
										if (this.hasRole(response.user.role1, 'ALL')) {
											sessionStorage.setItem("siteList", JSON.stringify(response.siteList));
											sessionStorage.setItem("hasTLORTM", 'true');
										}
										else {
											this.hasRole1(response.user.role1, response.siteList)
											sessionStorage.setItem("hasTLORTM", 'false');
										}
										response.user.role = this.formatRolesString(response.user.role1, response.user.primarySiteName);
										localStorage.setItem("userDetails", JSON.stringify(response.user));
										sessionStorage.setItem("userDetails", JSON.stringify(response.user));
										sessionStorage.setItem("siteConfigRules", JSON.stringify(response.siteConfigRules));
										sessionStorage.setItem("ALLsiteList", JSON.stringify(response.siteList));
										this.homeService.userDetails.emit(JSON.stringify(response.user));
										this.commonService.setRefresh(true);
										setTimeout(() => {
											this.ngxUiLoaderService.stop('loader-component');
										}, 500);
									}
									else if(response?.status == false){
										setTimeout(() => {
											this.ngxUiLoaderService.stop('loader-component');
										}, 500);
										localStorage.clear();
										sessionStorage.clear();
										// this.authService.logout();
										this.router.navigate(['/unauthorized', 'fvm','true']);
									}
									else {
										setTimeout(() => {
											this.ngxUiLoaderService.stop('loader-component');
										}, 500);
										localStorage.clear();
										sessionStorage.clear();
									}
								});
						}

						return of(true);
					}
					else {
						// this.router.navigate(['./unauthorized']);
						this.router.navigate(['/'])
						localStorage.clear();
						sessionStorage.clear();
						setTimeout(() => {
							this.authService.logout();
						}, 1000);
						return of(false);
					}
				})
			);
	}

	// private getScopesForEndpoint(endpoint: string): Array<string> | null {

	private getScopesForEndpoint(endpoint: string): any {
		const protectedResourcesArray = Array.from(this.msalInterceptorConfig.protectedResourceMap.keys());
		const keyMatchesEndpointArray = protectedResourcesArray.filter(key => {
			// const minimatch = new Minimatch(key);
			// return minimatch.match(endpoint) || endpoint.indexOf(key) > -1;
		});

		// process all protected resources and send the first matched resource
		if (keyMatchesEndpointArray.length > 0) {
			const keyForEndpoint = keyMatchesEndpointArray[0];
			if (keyForEndpoint) {
				return this.msalInterceptorConfig.protectedResourceMap.get(keyForEndpoint);
			}
		}

		return null;
	}

	private formatRolesString(role1: any, primarySiteName: string): any {
		let roleUniqueArr: any = [];
		if (role1) {
			let roleArr: any = [];

			if (role1['ALL']) {
				role1['ALL'].map((x: any) => {
					roleArr.push(x.name)
				})
			}
			if (role1[primarySiteName]) {
				role1[primarySiteName].map((x: any) => {
					roleArr.push(x.name)
				})
			}
			roleUniqueArr = Array.from(new Set(roleArr))
			roleUniqueArr.sort();
		}
		return roleUniqueArr;
	}

	private hasRole(role1: any, role: any) {
		if (role1) {
			if (role1[`${role}`]) {
				return role1[`${role}`].some((x: any) => {
					return (x.name == 'Team Member' || x.name == 'Team Leader')
				})
			}
		}
	}

	private hasRole1(role1: any, siteList: any) {
		if (role1) {
			let setSiteLIST: any = []
			for (let key in role1) {
				console.log(role1[key])
				role1[key].filter((x: any) => {
					console.log(x)
					if ((x.name == 'Team Member' || x.name == 'Team Leader') && x.sitename != 'ALL') {
						setSiteLIST.push(siteList.find((y: any) => y.name == x.sitename))
						return
					}

				})

			}
			const uniqueAuthors = setSiteLIST.reduce((accumulator: any, current: any) => {
				if (!accumulator.find((item: any) => item.id === current.id)) {
					accumulator.push(current);
				}
				return accumulator;
			}, []);
			sessionStorage.setItem("siteList", JSON.stringify(uniqueAuthors))
		}
	}

}

